@if (profil(); as p) {
  <button
    type="button"
    mat-mini-fab
    class="account-fab account-fab--eigen"
    [matMenuTriggerFor]="menu"
    [attr.aria-label]="'Profil von ' + p.name"
  >
    @if (p.bildUrl) {
      <img class="account-bild" alt="" [src]="p.bildUrl" />
    } @else {
      <span class="account-initialen">{{ p.initialen }}</span>
    }
  </button>
} @else if (claim()) {
  <button type="button" mat-mini-fab class="account-fab" [matMenuTriggerFor]="menu" aria-label="Profil">
    @if (claim()?.picture) {
      <img class="account-toggle avatar" alt="" [ngSrc]="claim()?.picture!" width="1" height="1" />
    } @else {
      <mat-icon class="account-toggle">account_circle</mat-icon>
    }
  </button>
}

<mat-menu #menu="matMenu">
  @if (profil(); as p) {
    <!-- Wer angemeldet ist, steht oben: bei einem gemeinsam benutzten Rechner die erste Frage. -->
    <div class="menue-kopf" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" role="presentation">
      @if (p.bildUrl) {
        <img class="menue-bild" alt="" [src]="p.bildUrl" />
      } @else {
        <span class="menue-initialen" aria-hidden="true">{{ p.initialen }}</span>
      }
      <span class="menue-text">
        <span class="mat-title-small">{{ p.name }}</span>
        <span class="mat-body-small menue-email">{{ p.email }}</span>
      </span>
    </div>
    <div class="menue-trenner" role="separator"></div>
  }
  <button type="button" mat-menu-item routerLink="profile">
    <mat-icon>manage_accounts</mat-icon>
    <span>{{ profil() ? 'Profil bearbeiten' : 'Profil' }}</span>
  </button>
  <button type="button" mat-menu-item (click)="dialog.open(pwDialog)">
    <mat-icon>lock</mat-icon>
    <span>Passwort ändern</span>
  </button>
  <div class="menue-trenner" role="separator"></div>
  <button type="button" mat-menu-item class="logout" (click)="logout()">
    <mat-icon>logout</mat-icon>
    <span>Abmelden</span>
  </button>
</mat-menu>

<ng-template #pwDialog>
  <h1 matDialogTitle>Passwort ändern</h1>
  <mat-dialog-content>
    <p>Melde dich dafür ab. Bei der nächsten Anmeldung klickst du auf <b>„Passwort vergessen?“</b>.</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" mat-button matDialogClose>Schließen</button>
    <button type="button" mat-button matDialogClose (click)="logout()">Abmelden</button>
  </mat-dialog-actions>
</ng-template>
